import { RadioGroup, Input, Stack } from '@etg/wings';
import { useValidation } from '@eti/providers';
import { Field } from 'redux-form';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const RadioGroupField = ({
  children,
  name,
  input,
  meta,
  isDisabled,
  ...rest
}) => {
  const hasError = Boolean(meta.touched && meta.error);
  const errorId = `${name}-error`;
  return /*#__PURE__*/_jsx(RadioGroup, {
    errorId: errorId,
    hasError: hasError,
    isDisabled: isDisabled,
    name: name,
    onChange: input.onChange,
    selectedValue: input.value,
    ...rest,
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: 4,
      children: [children, /*#__PURE__*/_jsx(Input.Meta, {
        error: meta.error,
        errorId: errorId,
        hasError: hasError
      })]
    })
  });
};
const ConnectedRadioGroup = ({
  children,
  isDisabled,
  name,
  validationRuleName,
  onChange,
  ...rest
}) => {
  const validate = useValidation(validationRuleName);
  return /*#__PURE__*/_jsx(Field, {
    component: RadioGroupField,
    name: name,
    onChange: onChange,
    props: {
      children,
      isDisabled,
      ...rest
    },
    validate: validate
  });
};
export default ConnectedRadioGroup;
//# sourceMappingURL=ConnectedRadioGroup.js.map